import '#lib/polyfills.js'
import * as Sentry from '@sentry/sveltekit'
import type { HandleClientError } from '@sveltejs/kit/hooks'
import { derived } from 'svelte/store'
import { CHUNK_LOAD_ERROR, isChunkLoadError } from '#lib/chunk-load-error.js'
import { REPLAY_SESSION_SAMPLE_RATE, SENTRY_OPTIONS } from '#lib/sentry.js'
import { sentryUser } from '#lib/sentry-user.js'
import { botTokenStore, userStore } from '#lib/store.js'

Sentry.init({
	...SENTRY_OPTIONS,
	// Replays record text, inputs and media unmasked. Card number and CVV stay out because they live
	// in Cybersource Microform iframes, which replays can't record; the expiry month and year are
	// plain inputs and do get recorded. Sentry always masks password inputs regardless of these options.
	integrations: [
		Sentry.replayIntegration({ maskAllText: false, maskAllInputs: false, blockAllMedia: false })
	],
	replaysSessionSampleRate: REPLAY_SESSION_SAMPLE_RATE,
	replaysOnErrorSampleRate: 1.0,
	// Also raised outside navigation (code preloading, hydration), where only the global handlers see them
	ignoreErrors: [CHUNK_LOAD_ERROR]
})

derived([userStore, botTokenStore], ([user, botToken]) => sentryUser(user, botToken)).subscribe(
	(user) => Sentry.setUser(user)
)

const reportError = Sentry.handleErrorWithSentry<HandleClientError>()

export const handleError: HandleClientError = (input) =>
	isChunkLoadError(input.error) ? { reason: 'network' } : reportError(input)
